(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }
  (function () {
    const OPEN_DELAY = 120;
    const CLOSE_DELAY = 220;

    function initHoverNav() {
      const nav = document.querySelector('.hl-nav');
      if (!nav) return;

      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const isDesktop = window.matchMedia('(min-width: 990px)');

      const items = Array.from(nav.querySelectorAll('.hl-nav__item'));
      let openTimer = null;
      let closeTimer = null;

      function hoverEnabled() {
        return canHover.matches && isDesktop.matches;
      }

      function closeAll(except) {
        items.forEach((item) => {
          const details = item.querySelector('.hl-nav__details');
          if (!details || details === except) return;
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      }

      function open(details) {
        if (!details || details.hasAttribute('open')) return;
        closeAll(details);
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function close(details) {
        if (!details) return;
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      items.forEach((item) => {
        const details = item.querySelector('.hl-nav__details');
        if (!details) return;
        const summary = details.querySelector('summary');

        item.addEventListener('mouseenter', () => {
          if (!hoverEnabled()) return;
          window.clearTimeout(closeTimer);
          window.clearTimeout(openTimer);
          openTimer = window.setTimeout(() => open(details), OPEN_DELAY);
        });

        item.addEventListener('mouseleave', () => {
          if (!hoverEnabled()) return;
          window.clearTimeout(openTimer);
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => close(details), CLOSE_DELAY);
        });

        if (summary) {
          summary.addEventListener('click', (event) => {
            const href = summary.getAttribute('data-href');

            // On hover-capable desktop, a click on an already-open trigger navigates.
            if (hoverEnabled() && href) {
              event.preventDefault();
              window.location.href = href;
              return;
            }

            // Touch / no-hover: let <details> toggle natively, but close siblings.
            if (!details.hasAttribute('open')) closeAll(details);
          });

          summary.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
              close(details);
              summary.focus();
            }
          });
        }

        details.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!details.contains(document.activeElement)) close(details);
          }, 0);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll(null);
      });

      nav.addEventListener('mouseleave', () => {
        if (!hoverEnabled()) return;
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => closeAll(null), CLOSE_DELAY);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverNav);
    } else {
      initHoverNav();
    }
  })();
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
